import { CatalogInfo } from './CatalogInfo';
import { GroupInfo } from './Group';

export class FamilyInfo extends CatalogInfo {
    GroupInfoList: GroupInfo[];
}
